import MessageBag from './MessageBag';

export default MessageBag;
